import React from 'react';
import { Section } from './ui/Section';
import { Button } from './ui/Button';
import { CheckCircle2, XCircle } from 'lucide-react';
import { motion } from 'framer-motion';
export const PricingSection = () => {
  return <Section id="compra" darker className="!py-8 md:!py-32" data-id="element-183">
      <div className="max-w-6xl mx-auto" data-id="element-184">
        <h2 className="text-3xl md:text-5xl font-bold text-center mb-6 md:mb-16 text-white leading-tight" data-id="element-185">
          Elegí tu opción
        </h2>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-4 md:gap-8 mb-8 md:mb-16" data-id="element-186">
          {/* Card 1: Base */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="bg-night-800 rounded-2xl md:rounded-3xl border border-night-700 p-5 md:p-8 flex flex-col relative" data-id="element-187">
            <div className="absolute -top-3 md:-top-4 left-1/2 -translate-x-1/2 bg-night-700 text-gray-300 text-[10px] md:text-xs font-bold px-3 md:px-4 py-1 rounded-full uppercase tracking-wider whitespace-nowrap" data-id="element-188">
              MÁS POPULAR
            </div>
            <h3 className="text-lg md:text-xl font-bold text-white mb-2 text-center mt-2 md:mt-0" data-id="element-189">
              SISTEMA BASE
            </h3>
            <div className="text-center mb-4 md:mb-6" data-id="element-190">
              <span className="text-gray-500 line-through text-sm md:text-lg mr-2" data-id="element-191">
                $39.990
              </span>
              <span className="text-3xl md:text-4xl font-bold text-white" data-id="element-192">
                $19.990
              </span>
            </div>
            <ul className="space-y-2.5 md:space-y-4 mb-5 md:mb-8 flex-1 text-sm md:text-base" data-id="element-193">
              <li className="flex items-start gap-2 md:gap-3" data-id="element-194">
                <CheckCircle2 className="w-4 h-4 md:w-5 md:h-5 text-cta shrink-0 mt-0.5" data-id="element-195" />
                <span className="text-gray-200 leading-tight" data-id="element-196">
                  6 tomos del sistema
                </span>
              </li>
              <li className="flex items-start gap-2 md:gap-3" data-id="element-197">
                <CheckCircle2 className="w-4 h-4 md:w-5 md:h-5 text-cta shrink-0 mt-0.5" data-id="element-198" />
                <span className="text-gray-200 leading-tight" data-id="element-199">
                  3 bonus exclusivos
                </span>
              </li>
              <li className="flex items-start gap-2 md:gap-3" data-id="element-200">
                <CheckCircle2 className="w-4 h-4 md:w-5 md:h-5 text-cta shrink-0 mt-0.5" data-id="element-201" />
                <span className="text-gray-200 leading-tight" data-id="element-202">
                  Acceso inmediato en PDF
                </span>
              </li>
            </ul>
            <div className="mt-auto space-y-2" data-id="element-203">
              <Button href="https://menteencalma.com.ar/checkouts/cn/hWNBKxBaosKN872HEUa7MHCM/es-ar?_r=AQAB8w_-WKsgm5DV6wGG57FdEsxQ7vdhVDMyXyIQ1ADw2cI" fullWidth className="!py-3.5 md:!py-4 !text-base md:!text-lg" data-id="element-204">
                EMPEZAR AHORA
              </Button>
              <p className="text-center text-[10px] md:text-xs text-gray-400 font-medium" data-id="element-205">
                ⚡ Acceso inmediato · 🔒 Pago seguro
              </p>
            </div>
          </motion.div>

          {/* Card 2: Rescate */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.1
        }} className="bg-night-800 rounded-2xl md:rounded-3xl border border-night-700 p-5 md:p-8 flex flex-col relative" data-id="element-206">
            <div className="absolute -top-3 md:-top-4 left-1/2 -translate-x-1/2 bg-night-700 text-gray-300 text-[10px] md:text-xs font-bold px-3 md:px-4 py-1 rounded-full uppercase tracking-wider whitespace-nowrap" data-id="element-207">
              MÁS COMPLETO
            </div>
            <h3 className="text-lg md:text-xl font-bold text-white mb-1 md:mb-2 text-center mt-2 md:mt-0" data-id="element-208">
              SISTEMA + RESCATE
            </h3>
            <div className="text-center mb-3 md:mb-4" data-id="element-209">
              <span className="text-gray-500 line-through text-sm md:text-lg mr-2" data-id="element-210">
                $59.990
              </span>
              <span className="text-3xl md:text-4xl font-bold text-white" data-id="element-211">
                $29.990
              </span>
            </div>
            <ul className="space-y-2.5 md:space-y-4 mb-5 md:mb-8 flex-1 text-sm md:text-base" data-id="element-212">
              <li className="flex items-start gap-2 md:gap-3" data-id="element-213">
                <CheckCircle2 className="w-4 h-4 md:w-5 md:h-5 text-cta shrink-0 mt-0.5" data-id="element-214" />
                <span className="text-gray-200 leading-tight" data-id="element-215">
                  6 tomos del sistema
                </span>
              </li>
              <li className="flex items-start gap-2 md:gap-3" data-id="element-216">
                <CheckCircle2 className="w-4 h-4 md:w-5 md:h-5 text-cta shrink-0 mt-0.5" data-id="element-217" />
                <span className="text-gray-200 leading-tight" data-id="element-218">
                  3 bonus exclusivos
                </span>
              </li>
              <li className="flex items-start gap-2 md:gap-3" data-id="element-219">
                <CheckCircle2 className="w-4 h-4 md:w-5 md:h-5 text-cta shrink-0 mt-0.5" data-id="element-220" />
                <span className="text-white font-bold leading-tight" data-id="element-221">
                  Guía "Qué Hacer Cuando No Podés Dormir"
                </span>
              </li>
              <li className="flex items-start gap-2 md:gap-3" data-id="element-222">
                <CheckCircle2 className="w-4 h-4 md:w-5 md:h-5 text-cta shrink-0 mt-0.5" data-id="element-223" />
                <span className="text-gray-200 leading-tight" data-id="element-224">
                  Acceso inmediato en PDF
                </span>
              </li>
            </ul>
            <div className="mt-auto space-y-2" data-id="element-225">
              <Button href="https://menteencalma.com.ar/checkouts/cn/hWNBKxFXlXGQQMS97G3nskqo/es-ar?_r=AQABVYxNPvx2jjfI11UYA89uSqEjhJrfaJNgLOlCSAzwqKo" fullWidth className="!py-3.5 md:!py-4 !text-base md:!text-lg" data-id="element-226">
                QUIERO ESTE
              </Button>
              <p className="text-center text-[10px] md:text-xs text-gray-400 font-medium" data-id="element-227">
                ⚡ Acceso inmediato · 🔒 Pago seguro
              </p>
            </div>
          </motion.div>

          {/* Card 3: Completo */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.2
        }} className="bg-night-800 rounded-2xl md:rounded-3xl border border-night-700 p-5 md:p-8 flex flex-col relative" data-id="element-228">
            <div className="absolute -top-3 md:-top-4 left-1/2 -translate-x-1/2 bg-night-700 text-gray-300 text-[10px] md:text-xs font-bold px-3 md:px-4 py-1 rounded-full uppercase tracking-wider whitespace-nowrap" data-id="element-229">
              MEJOR VALOR
            </div>
            <h3 className="text-lg md:text-xl font-bold text-white mb-1 md:mb-2 text-center mt-2 md:mt-0" data-id="element-230">
              SISTEMA COMPLETO
            </h3>
            <div className="text-center mb-3 md:mb-4" data-id="element-231">
              <span className="text-gray-500 line-through text-sm md:text-lg mr-2" data-id="element-232">
                $69.990
              </span>
              <span className="text-3xl md:text-4xl font-bold text-white" data-id="element-233">
                $39.990
              </span>
            </div>
            <ul className="space-y-2.5 md:space-y-4 mb-5 md:mb-8 flex-1 text-sm md:text-base" data-id="element-234">
              <li className="flex items-start gap-2 md:gap-3" data-id="element-235">
                <CheckCircle2 className="w-4 h-4 md:w-5 md:h-5 text-cta shrink-0 mt-0.5" data-id="element-236" />
                <span className="text-gray-200 leading-tight" data-id="element-237">
                  6 tomos del sistema
                </span>
              </li>
              <li className="flex items-start gap-2 md:gap-3" data-id="element-238">
                <CheckCircle2 className="w-4 h-4 md:w-5 md:h-5 text-cta shrink-0 mt-0.5" data-id="element-239" />
                <span className="text-gray-200 leading-tight" data-id="element-240">
                  3 bonus exclusivos
                </span>
              </li>
              <li className="flex items-start gap-2 md:gap-3" data-id="element-241">
                <CheckCircle2 className="w-4 h-4 md:w-5 md:h-5 text-cta shrink-0 mt-0.5" data-id="element-242" />
                <span className="text-white font-bold leading-tight" data-id="element-243">
                  Guía "Qué Hacer Cuando No Podés Dormir"
                </span>
              </li>
              <li className="flex items-start gap-2 md:gap-3" data-id="element-244">
                <CheckCircle2 className="w-4 h-4 md:w-5 md:h-5 text-cta shrink-0 mt-0.5" data-id="element-245" />
                <span className="text-white font-bold leading-tight" data-id="element-246">
                  Guía "Por Qué No Podes Apagar la Cabeza y Cómo Frenarlo"
                </span>
              </li>
              <li className="flex items-start gap-2 md:gap-3" data-id="element-247">
                <CheckCircle2 className="w-4 h-4 md:w-5 md:h-5 text-cta shrink-0 mt-0.5" data-id="element-248" />
                <span className="text-gray-200 leading-tight" data-id="element-249">
                  Acceso inmediato en PDF
                </span>
              </li>
            </ul>
            <div className="mt-auto space-y-2" data-id="element-250">
              <Button href="https://menteencalma.com.ar/checkouts/cn/hWNBKxIIguaHAXOt34w0TveM/es-ar?_r=AQABs2XVB8jPvy1MWMwycVRP65KoCwB-iYa1mi6mXi_Jw8c" fullWidth className="!py-3.5 md:!py-4 !text-base md:!text-lg" data-id="element-251">
                LLEVO EL COMPLETO
              </Button>
              <p className="text-center text-[10px] md:text-xs text-gray-400 font-medium" data-id="element-252">
                ⚡ Acceso inmediato · 🔒 Pago seguro
              </p>
            </div>
          </motion.div>
        </div>

        {/* Comparison Table - Hidden on mobile */}
        <div className="hidden md:block overflow-x-auto bg-night-800 rounded-2xl border border-night-700 p-6 md:p-8" data-id="element-253">
          <table className="w-full text-left border-collapse min-w-[600px]" data-id="element-254">
            <thead data-id="element-255">
              <tr className="border-b border-night-700" data-id="element-256">
                <th className="py-4 px-4 text-gray-400 font-semibold" data-id="element-257">
                  ¿Qué incluye?
                </th>
                <th className="py-4 px-4 text-cta font-bold text-center" data-id="element-258">
                  BASE
                </th>
                <th className="py-4 px-4 text-white font-semibold text-center" data-id="element-259">
                  RESCATE
                </th>
                <th className="py-4 px-4 text-accent-light font-bold text-center" data-id="element-260">
                  COMPLETO
                </th>
              </tr>
            </thead>
            <tbody className="divide-y divide-night-700/50" data-id="element-261">
              <tr data-id="element-262">
                <td className="py-4 px-4 text-gray-300" data-id="element-263">6 Tomos del sistema</td>
                <td className="py-4 px-4 text-center" data-id="element-264">
                  <CheckCircle2 className="w-5 h-5 text-cta mx-auto" data-id="element-265" />
                </td>
                <td className="py-4 px-4 text-center" data-id="element-266">
                  <CheckCircle2 className="w-5 h-5 text-gray-500 mx-auto" data-id="element-267" />
                </td>
                <td className="py-4 px-4 text-center" data-id="element-268">
                  <CheckCircle2 className="w-5 h-5 text-accent-blue mx-auto" data-id="element-269" />
                </td>
              </tr>
              <tr data-id="element-270">
                <td className="py-4 px-4 text-gray-300" data-id="element-271">3 Bonus exclusivos</td>
                <td className="py-4 px-4 text-center" data-id="element-272">
                  <CheckCircle2 className="w-5 h-5 text-cta mx-auto" data-id="element-273" />
                </td>
                <td className="py-4 px-4 text-center" data-id="element-274">
                  <CheckCircle2 className="w-5 h-5 text-gray-500 mx-auto" data-id="element-275" />
                </td>
                <td className="py-4 px-4 text-center" data-id="element-276">
                  <CheckCircle2 className="w-5 h-5 text-accent-blue mx-auto" data-id="element-277" />
                </td>
              </tr>
              <tr data-id="element-278">
                <td className="py-4 px-4 text-gray-300" data-id="element-279">
                  Guía de rescate nocturno
                </td>
                <td className="py-4 px-4 text-center" data-id="element-280">
                  <XCircle className="w-5 h-5 text-night-700 mx-auto" data-id="element-281" />
                </td>
                <td className="py-4 px-4 text-center" data-id="element-282">
                  <CheckCircle2 className="w-5 h-5 text-gray-500 mx-auto" data-id="element-283" />
                </td>
                <td className="py-4 px-4 text-center" data-id="element-284">
                  <CheckCircle2 className="w-5 h-5 text-accent-blue mx-auto" data-id="element-285" />
                </td>
              </tr>
              <tr data-id="element-286">
                <td className="py-4 px-4 text-gray-300" data-id="element-287">
                  Sistema anti recaída
                </td>
                <td className="py-4 px-4 text-center" data-id="element-288">
                  <XCircle className="w-5 h-5 text-night-700 mx-auto" data-id="element-289" />
                </td>
                <td className="py-4 px-4 text-center" data-id="element-290">
                  <XCircle className="w-5 h-5 text-night-700 mx-auto" data-id="element-291" />
                </td>
                <td className="py-4 px-4 text-center" data-id="element-292">
                  <CheckCircle2 className="w-5 h-5 text-accent-blue mx-auto" data-id="element-293" />
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </Section>;
};